<template>
    <div>
        <fieldset>
            <!-- How can we afford to do this for free? -->
            <template v-if="isUserSignUp">
                <div class="space-y-2 mt-7">
                    <h4 class="text-lg font-semibold text-gray-900">How we keep this free for you</h4>
                    <p class="text-sm font-medium block text-gray-600">
                        Our mission is to help as many homeowners as possible. It costs real money to run this, so we fund it two ways: some homeowners later hire our real estate team, and others pay it forward to keep protests free for the next family. No obligation either way.
                    </p>
                </div>

                <div>
                    <h4 class="font-medium text-gray-900 mb-3 mt-6">1. Real Estate</h4>

                    <!--Hire realtor-->

                    <div>
                        <label class="block text-sm font-medium text-gray-600 mb-3">
                          Even if you are not planning to move anytime soon, if you ever buy or sell a home, how likely are you to interview our team of Realtors to help you? <a href="https://www.chandlercrouch.com/reviews" target="_blank" class=" text-indigo-500">(Read our reviews)</a>
                        </label>

                        <div class="flex items-start md:items-end flex-col md:flex-row"
                            :class="{ 'border border-red-500 p-1 rounded': errors.willing_to_hire_realtor }">
                            <label class="block text-sm font-medium text-gray-700">
                                Not likely
                            </label>

                            <div
                                class="grid grid-cols-1 sm:grid-cols-11 gap-4 sm:flex-1 sm:max-w-xl my-2 md:my-0 md:mx-6">
                                <div class="inline-flex items-center justify-self-start sm:justify-center flex-row-reverse sm:flex-col sm:text-center"
                                    v-for="(number, index) in 11" :key="index">
                                    <label :for="['hire_realtor_' + index]"
                                        class="block text-sm font-medium text-gray-700 ml-3 sm:ml-0 sm:mb-2">
                                        {{ index }}
                                    </label>
                                    <input :id="['hire_realtor_' + index]" :value="index" name="willing_to_hire_realtor"
                                        v-model="donationPageData.willing_to_hire_realtor" type="radio"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300" />
                                </div>
                            </div>

                            <label class="block text-sm font-medium text-gray-700">
                                Very likely
                            </label>
                        </div>

                        <div class="text-red-600 text-sm px-1 py-1" v-if="errors.willing_to_hire_realtor">
                            <i class="fa fa-exclamation-triangle"></i> {{ errors.willing_to_hire_realtor }}
                        </div>
                    </div>


                    <!--Optional: additional comments-->

                    <div class="mt-5 ml-2">
                        <label class="block text-sm font-medium text-gray-600 mb-2">
                            Anything you want us to know about your real estate plans (optional)
                        </label>

                        <div>
                            <input type="text" maxlength="250" placeholder="Example: not moving for 3 years, possibly upsizing, looking in Keller"
                                v-model="donationPageData.real_estate_additional_comments"
                                class="block border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 ml-2 px-2 py-1.5 rounded-md shadow-sm text-xs w-full">
                        </div>
                    </div>
                    <div class="text-red-600 text-sm px-1 py-1" v-if="errors.real_estate_additional_comments">
                        <i class="fa fa-exclamation-triangle"></i> {{ errors.real_estate_additional_comments }}
                    </div>

                </div>
            </template>
            <template v-else>
                <div class="space-y-2 mt-7">
                    <h4 class="text-lg font-semibold text-gray-900">
                        Thank you for letting us protest your {{ REGISTRATION_YEAR }} value
                    </h4>
                    <p class="text-sm font-medium block text-gray-600 mt-2">
                        Your protest is free because others chipped in. Will you chip in to pay it forward for the next
                        homeowner?</p>
                    <ul class="list-disc list-inside mt-1 text-sm font-medium block text-gray-600">
                        <li>
                            <b>Almost 40,000 homeowners</b>
                            trusted us last year, and we won
                            <b>99.93% </b>of their protests.
                        </li>
                        <li>
                            Chandler meets regularly with TAD executives and lawmakers to push for fairer appraisal
                            policies.

                        </li>
                        <li>
                            Last year, we reduced more than <b> $2 billion</b> from tax values.
                        </li>
                    </ul>

                    <p class=" mt-2 text-sm font-medium block text-gray-600">
                        Every dollar you give keeps protests free for the next family and fuels taxpayer‑focused
                        reforms.
                    </p>
                </div>
            </template>

            <!-- Pay it forward -->
            <div v-if="isUserSignUp">
                <h4 class="font-medium text-gray-900 mb-3 mt-6 sm:mt-8">2. Pay it forward (optional)</h4>
                <label class="block text-sm font-medium text-gray-600 mb-3">
                    If you want to pay it forward and help keep protests free for the next family, any amount helps.
                </label>
            </div>
            <div class="bg-gray-50 bg-opacity-50 px-5 py-4 mt-2 rounded">
                <div>
                    <div>
                        <div :class="{
                        'border border-red-500 p-1 rounded': errors.donation_amount
                    }" class="bg-white flex rounded-md shadow-sm   overflow-hidden  ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-purple-600">
                            <span
                            class="flex items-center pl-3 text-gray-500 text-lg select-none font-semibold">$</span>
                            <input type="number" name="donation_amount" v-model="donationPageData.donation_amount" min=0
                            class="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                placeholder="Enter any amount">
                        </div>
                    </div>
                    <div class="text-red-600 text-sm px-1 py-1" v-if="errors.donation_amount">
                        <i class="fa fa-exclamation-triangle"></i>
                        {{ errors.donation_amount }}
                    </div>

                    <!-- Donation Suggestions -->
                    <div class="flex gap-x-1.5 items-center ml-1 mt-1.5"
                        v-if="donationSuggestion && (donationSuggestion.low || donationSuggestion.medium || donationSuggestion.high)">
                        <label class="block text-sm font-medium text-gray-700">Quick Options:</label>
                        <button
                            v-for="amount in [donationSuggestion.low, donationSuggestion.medium, donationSuggestion.high]"
                            :key="amount" @click="fillSuggestionAmount(amount)"
                            class="px-3 py-1 text-xs font-medium text-blue-700 border border-blue-300 rounded hover:bg-blue-600 hover:text-white transition">
                            ${{ amount }}
                        </button>
                    </div>
                    <p class="mt-2 italic text-xs font-medium block text-gray-600">
                       To skip, enter 0 then click Continue.
                    </p>
                </div>
            </div>

            <!-- <div class="mt-7 text-sm font-medium text-gray-800">
                By submitting this form, I agree to
                <a href='/pages/terms-and-condition' target="_blank" class="underline text-indigo-500">
                    Terms and Conditions
                </a>
            </div> -->

            <div class="border-t mt-4 sm:mt-6 pt-4 sm:pt-6" :class="{ '': errors.agree_to_terms_and_conditions }">
                <div class="flex items-center pl-4">
                    <input id="agreement_1" type="checkbox" name="agreement"
                        v-model="donationPageData.agree_to_terms_and_conditions" value="agree_yes"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 mr-2" />
                    <label for="agreement_1" class="ml-1 mt-1 block text-sm font-medium text-gray-700">
                        I have read and agree to the <a href='/pages/terms-and-condition' target="_blank"
                            class="underline text-indigo-500">Terms & Conditions</a>
                    </label>
                </div>

                <div class="pl-4 pt-2 pr-1 pb-1 text-red-600 text-sm" v-if="errors.agree_to_terms_and_conditions">
                    <i class="fa fa-exclamation-triangle"></i> {{ errors.agree_to_terms_and_conditions }}
                </div>
            </div>


        </fieldset>
        <div class="w-full mt-4 sm:mt-6 text-center " v-if="!isUserSignUp">
            <button @click="submit()"
                class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">
                Continue </button>
        </div>
    </div>
</template>

<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
import { registrationYear } from "../../../../../config/base";

export default {
    props: ['user-property', 'isUserSignUp', 'donationPageData', 'errors', 'donationSuggestion'],
    data() {
        return {
            isSubmitButton: false,
            REGISTRATION_YEAR: registrationYear,
        }
    },
    created() {
        console.log(this.donationSuggestion)
        if (this.donationPageData == null) {
            this.donationPageData = {}
        }
        if (this.errors == null) {
            this.errors = {};
        }
    },
    methods: {
        submit() {
            if (this.validateData()) {
                flash(
                    "A required question needs to be answered. Please review your answers below",
                    "error"
                );
                return;
            }
            window.blockUI();
            ProtestRequestApi.storeConfirmToProtest(this.userProperty.uid, this.donationPageData)
                .then((response) => {
                    if (response.data.error == false) {
                        window.location.href = response.data.redirectUrl;
                        window.unblockUI();
                    } else {
                        alert("ERR1045: " + res.data.message);
                    }
                }).catch((error_response) => {
                    alert("ERR1045: System Error. Please contact administrator");
                    console.log(error_response);
                })
                .finally(() => {
                    this.isProcessing = false;
                    window.unblockUI();
                });
        },
        validateData() {
            this.errors = {};
            let error = false;
            if (this.donationPageData.agree_to_terms_and_conditions == null || this.donationPageData.agree_to_terms_and_conditions == "") {
                this.errors.agree_to_terms_and_conditions = "Please agree to terms.";
                error = true;
            }
            if (
                this.donationPageData.donation_amount == null ||
                this.donationPageData.donation_amount == ""
            ) {
                this.errors.donation_amount = "Please enter 0 or more amount.";
                error = true;
            }
            return error;
        },
        fillSuggestionAmount(amount) {

            this.$set(this.donationPageData, 'donation_amount', amount);
            this.$forceUpdate();

        }
    },
    // watch: {
    //     data: {
    //         deep: true,
    //         handler: function (val, oldVal) {
    //             this.$emit("donation-page", this.data);
    //         },
    //     },
    // },
}
</script>
